import React, { useState } from 'react';
import { SocketProvider } from './contexts/SocketContext';
import { WebRTCProvider } from './contexts/WebRTCContext';
import { CssVarsProvider } from '@mui/joy/styles';
import TabsRoot from './components/TabsRoot';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import LoginPage from './components/LoginPage';

function App() {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [userCredentials, setUserCredentials] = useState({ roomId: '', password: '' });

    const handleLogin = (roomId, password) => {
        setIsAuthenticated(true);
        setUserCredentials({ roomId, password });  // Store user credentials
    };

    return (
        <Router>
            <Routes>
                {/* Define Routes */}
                <Route
                    path="/login"
                    element={!isAuthenticated ? <LoginPage onLogin={handleLogin} /> : <Navigate to="/home" />}
                />

                {/* Main App */}
                <Route
                    path="/home"
                    element={isAuthenticated ? (
                        <SocketProvider roomId={userCredentials.roomId} password={userCredentials.password}>
                            <WebRTCProvider>
                                <CssVarsProvider>
                                    <div className="App">
                                        <TabsRoot />
                                    </div>
                                </CssVarsProvider>
                            </WebRTCProvider>
                        </SocketProvider>
                    ) : (
                        <Navigate to="/login" />
                    )}
                />

                {/* Default Route */}
                <Route path="/" element={<Navigate to="/login" />} />
            </Routes>
        </Router>
    );
}

export default App;
